import { FetchResult } from 'apollo-link'
import gql from 'graphql-tag'
import { getApolloClient, handleGraphQLErrors } from '../../../../../../../getApolloClient'
import { ClientManualInsuranceUpload } from '../../../../../../../redux/State/Client/Profile/IClientProfile'

export async function postInsuranceCoverageManual (
  insuranceCoverage: ClientManualInsuranceUpload,
  accessToken?: string,
  clientId?: string,
): Promise<any> {
  type Result = FetchResult<{postInsuranceCoverageManual: any}>

  return getApolloClient()
    .then(apolloClient =>
      apolloClient.mutate({
        mutation: gql`
          mutation PostInsuranceCoverageManual($insuranceCoverage: InsuranceCoverageManual!, $credentials: CredentialsInput!, $clientId: String) {
            postInsuranceCoverageManual(insuranceCoverage: $insuranceCoverage, credentials: $credentials, clientId: $clientId) {
              status
              insuranceCoverageUUID
            }
          }
        `,
        variables: {
          clientId,
          credentials: {
            accessToken,
          },
          insuranceCoverage,
        },
      }),
    )
    .then((result: Result) => {
      if (result.errors) {
        console.error({ result })
        throw result.errors[0]
      }
      if (!result.data) throw new Error('!result.data')
      return result.data.postInsuranceCoverageManual
    })
    .catch(handleGraphQLErrors)
}
